import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=6ef6740e"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&id=6ef6740e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports